module.exports = __webpack_public_path__ + "static/media/shop.c1ed3693.jpeg";